// extracted by mini-css-extract-plugin
export default {"container":"CurrentPlace--container--2iZvO"};